
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import validate from "@/common/regular";
import { addManufacturer, updManufacturer } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class PiProducerAdd extends Vue {
  private modalShow = false;
  private modalTitle = "";
  private loading = false;
  private formInline: objAny = {
    brandName: "",
    busLicenseNumber: "",
    contactName: "",
    legalIdCard: "",
    legalPerson: "",
    manufacturerId: "",
    manufacturerName: "",
    manufacturerPkId: "",
    phoneNo: ""
  };

  private isAdd = false;
  private itemData: objAny = {};
  private formObj: objAny = {};
  private ruleInline: objAny = {
    busLicenseNumber: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.busLicenseNumberPl") + "");
          } else if (value.length < 18) {
            return new Error(i18n.t("producer.busLicenseNumberMax") + "");
          }
          return true;
        }
      }
    ],
    brandName: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.brandNamePl") + "");
          }
          return true;
        }
      }
    ],
    manufacturerName: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.manufacturerNamePl") + "");
          }
          return true;
        }
      }
    ],

    manufacturerId: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.manufacturerIdPl") + "");
          } else if (value.length < 9) {
            return new Error(i18n.t("producer.manufacturerIdMax") + "");
          }
          return true;
        }
      }
    ],
    legalPerson: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.legalPersonPl") + "");
          }
          return true;
        }
      }
    ],
    legalIdCard: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.legalIdCardPl") + "");
          } else if (value.length < 18) {
            return new Error(i18n.t("producer.legalIdCardMax") + "");
          }
          return true;
        }
      }
    ],
    contactName: [
      {
        required: true,
        trigger: "blur",
        validator: (rule: objAny, value: string) => {
          if (!value) {
            return new Error(i18n.t("producer.contactNamePl") + "");
          }
          return true;
        }
      }
    ],
    phoneNo: [
      {
        required: true,
        validator: validate.tel,
        trigger: "blur"
      }
    ]
  };

  public getManufacturerId() {
    if (this.formInline.busLicenseNumber.length < 18) {
      return;
    }
    this.formInline.manufacturerId = this.formInline.busLicenseNumber.substring(
      1,
      10
    );
    this.$forceUpdate();
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.loading = true;
        if (this.isAdd) {
          this.addManufacturerItem();
        } else {
          this.updManufacturerItem();
        }
      }
    });
  }

  async addManufacturerItem(): Promise<void> {
    const ret = await addManufacturer(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess") + "");
      this.$emit("success");
      this.closeModal();
    }
    this.loading = false;
  }

  async updManufacturerItem(): Promise<void> {
    const ret = await updManufacturer(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("updateSuccess") + "");
      this.$emit("success");
      this.closeModal();
    }
    this.loading = false;
  }

  open(itemData?: objAny) {
    this.modalShow = true;
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
      this.handleReset();

      if (!itemData) {
        this.isAdd = true;
        this.modalTitle = i18n.t("producer.add") + "";
        this.formInline.brandName = "";
        this.formInline.busLicenseNumber = "";
        this.formInline.contactName = "";
        this.formInline.legalIdCard = "";
        this.formInline.legalPerson = "";
        this.formInline.manufacturerId = "";
        this.formInline.manufacturerName = "";
        this.formInline.manufacturerPkId = "";
        this.formInline.phoneNo = "";
      } else {
        this.isAdd = false;
        this.modalTitle = i18n.t("producer.updata") + "";
        this.formInline.brandName = itemData.brandName;
        this.formInline.busLicenseNumber = itemData.busLicenseNumber;
        this.formInline.contactName = itemData.contactName;
        this.formInline.legalIdCard = itemData.legalIdCard;
        this.formInline.legalPerson = itemData.legalPerson;
        this.formInline.manufacturerId = itemData.manufacturerId;
        this.formInline.manufacturerName = itemData.manufacturerName;
        this.formInline.manufacturerPkId = itemData.manufacturerPkId;
        this.formInline.phoneNo = itemData.phoneNo;
      }
    });
  }
  handleReset() {
    this.formObj.resetFields();
  }
  closeModal() {
    this.modalShow = false;
  }
}
